import { Store } from "@ngxs/store";
import { TealHealthEncounter } from "../../../models/encounter";
import { EncounterService } from "../../../services/encounter.service";
import { Fax, FaxWrite, HarloweSupport, IFaxHandler, User } from "@harlowe/core";
import { UtilService } from "../../../services/util.service";


export class EncounterFaxHandler implements IFaxHandler {
    constructor
    (
        private _encounter: TealHealthEncounter,
        private _encounterService: EncounterService,
        private _utilService: UtilService,
        private _store: Store,

    )
    {
        this.isReady = false;
    }

    getAttachments(): Map<string, HarloweSupport.File[]> {
        var retMap = new Map();
        retMap.set("Attachments",this._encounter.attachments);
        return retMap;
    }

    async create(): Promise<EncounterFaxHandler>
    {
        if (this._encounter.patientMember?.person)
        {
            this.patientFirstName = this._encounter.patientMember.person.firstName;
            this.patientFirstName = this.patientFirstName.toLowerCase();
            this.patientFirstName = this.patientFirstName.charAt(0).toUpperCase() + this.patientFirstName.slice(1);

            this.patientLastName = this._encounter.patientMember.person.lastName;
            this.patientLastName = this.patientLastName.toLowerCase(); 
            this.patientLastName = this.patientLastName.charAt(0).toUpperCase() + this.patientLastName.slice(1);

            this.patientMemberId = this._encounter.patientMember.memberId.toString();
            this.isReady = true;
        }

        return this;
    }

    isReady: boolean;
    patientFirstName?: string | undefined;
    patientLastName?: string | undefined;
    patientMemberId?: string | undefined;

    private getSubject(): string {
        // Start with longest, most descriptive subject, shorten until it's <=55 characters.
        var subject = "Prior Authorization for " + this.patientFirstName + " " + this.patientLastName
            + " (Enc# " + this._encounter.id + ")";

        if (subject.length > 55) {
            subject = "Prior Authorization for " + this.patientFirstName?.substring(0, 1) + " " + this.patientLastName
                + " (Enc# " + this._encounter.id + ")";
        }

        if (subject.length > 55) {
            subject = "Prior Auth for " + this.patientFirstName + " " + this.patientLastName
                + " (Enc# " + this._encounter.id + ")";
        }

        if (subject.length > 55) {
            subject = "Prior Auth for " + this.patientFirstName?.substring(0, 1) + " " + this.patientLastName;
            +" (Enc# " + this._encounter.id + ")";
        }

        if (subject.length > 55) {
            subject = "PA for " + this.patientFirstName + " " + this.patientLastName
                + " (Enc# " + this._encounter.id + ")";
        }

        if (subject.length > 55) {
            subject = "PA for " + this.patientFirstName?.substring(0, 1) + " " + this.patientLastName
                + " (Enc# " + this._encounter.id + ").";
        }

        return subject;
    }

    newFax(user: User, rmc: boolean): FaxWrite {
        var subject = this.getSubject();

        var notes = "Attached is the updated Prior Auth for " + this.patientFirstName + " " + this.patientLastName + ".\n\n"
            + "Thank you for your assistance.\n\nSincerely,\n"
            + user.firstName + " " + user.lastName + ", Nurse Navigator\n"
            + (rmc ? "Reduce My Costs\n" : "Harlowe Health\n")
            + user.emailAddresses[0].split('@')[0] + "@" + (rmc ? "reducemycostsnurses.com" : "harlowehealth.com") + "\n"
            + "(" + user.hemiPhoneNumber?.substring(0,3) + ") " + user.hemiPhoneNumber?.substring(3,6) + "-" + user.hemiPhoneNumber?.substring(6);

        var pendingFax = new FaxWrite('', user.fullName, subject, notes, '');

        return pendingFax;
    }

    cgiRefNumber(): string {
        return "TN" + this._encounter.id + this.patientFirstName?.substring(0,1) + this.patientLastName?.substring(0,1);
    }

    newCgiFax(user: User) : FaxWrite {
        var subject = this.getSubject();
        var notes = "Attached are ORDERS for " + this.patientFirstName + " " + this.patientLastName + ".\n\n"
            + "Member ID: " + this.patientMemberId + "\n\n"
            + "***** This member is HPI, no authorization is needed *****\n"
            + "***** If a PA/Reference # is desired, please use: " + this.cgiRefNumber() + " *****\n"
            + "(For additional information, please refer to https://hpitpa.com/precert)\n\n"
            + "Thank you for your assistance.\n\nSincerely,\n"
            + user.firstName + " " + user.lastName + ", Nurse Navigator\n"
            + "CGI Clinical Concierge\n"
            + user.emailAddresses[0].split('@')[0] + "@cgiclinical.com" + "\n"
            + "(" + user.hemiPhoneNumber?.substring(0,3) + ") " + user.hemiPhoneNumber?.substring(3,6) + "-" + user.hemiPhoneNumber?.substring(6);
            
        var pendingFax = new FaxWrite('', user.fullName, subject, notes, '');

        return pendingFax;
    }

    async previewFile(file: HarloweSupport.File)
    {
        // show popup with invoice PDF
        console.log(file);
        
        await this._utilService.getFileBlob(file)
        .then
        (
        (blob: Blob) =>
        {
            if (blob.size == 0)
            {
                return;
            }
            
            console.log(blob);
            const url = window.URL.createObjectURL(blob);
            let pwa = window.open(url,"Preview","height=640,width=960,toolbar=no,menubar=no,scrollbars=no,location=no,status=no");
        }
        )
        .catch
        (
        (e: { error: any; }) =>
        {
            console.log(e);
        }
        )    
    }

    async sendFax(fax: FaxWrite): Promise<Fax>
    {
        //send the fax
        return this._encounterService.sendEncounterFax(this._encounter?.id as number, fax);
    }
}
